import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DependencyStatus } from '../../models/service.model';

@Component({
  selector: 'fin-api-status-card',
  standalone: true,
  templateUrl: './api-status-card.component.html',
  styleUrls: ['./api-status-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgForOf, NgIf],
})
export class ApiStatusCardComponent {
  @Input() name!: string;
  @Input() status!: 'OK' | 'ERROR' | 'LOADING';
  @Input() description!: string;
  @Input() dependencies: DependencyStatus[] = [];
}
